module.exports = {}



// WEBPACK FOOTER //
// ./src/lang/i18nHANT.js